import React, { useEffect, useState } from "react";
import {
  Modal,
  ConfigProvider,
  Divider,
} from "antd";
import CustomInput from "../CustomInput";
import { constants } from "../../constant/constants";
import useScrollLock from "../../hooks/useScrollLock";

function ConfirmationModal({ openModal, records }) {
  const [cookingTime, setCookingTime] = useState("");
  const [error, setError] = useState("");

  // Lock scroll when modal is open
  useScrollLock(openModal);

  const clearFields = () => {
    setCookingTime("");
    setError("");
  };
  
  const handleOk = () => {
    if (records.action === constants.ORDER.WAITING) {
      if (!cookingTime) {
        setError("Cooking Time Required");
        return;
      }
    }
    records.param.cookingTime = cookingTime;
    records.onFinish(records.param, records.action);
    clearFields();
  };

  const handleCancel = () => {
    records.onCancel();
    clearFields();
  };

  const updateCookingTime = (val) => {
    if (/^\d*$/.test(val)) {
      setCookingTime(val);
    }
  };

  return (
    <ConfigProvider
      theme={{
        components: {
          Button: {
            defaultHoverBorderColor: "#FFD700",
            defaultHoverColor: "#000000",
            fontFamily: "ubold",
          },
        },
      }}
    >
      <Modal
        maskClosable={false}
        open={openModal}
        okButtonProps={{
          style: {
            backgroundColor: "#FFD700",
            color: "#000000",
            fontFamily: "ubold",
          },
        }}
        onOk={handleOk}
        okText={"Yes"}
        onCancel={handleCancel}
        centered
      >
        <div className="flex flex-col font-uregular">
          <div className="text-2xl font-ubold">Change Status</div>
          <Divider />
          {records.titleMessage && (
            <div
              className="text-lg font-ubold mb-[24px]"
              dangerouslySetInnerHTML={{ __html: records.titleMessage }}
            />
          )}

          {records.param?.tableNumber && (
            <div
              className="text-lg font-ubold mb-[24px]"
            >
              Table # {records.param?.tableNumber}  
            </div>
          )}
          
          <div
            className="text-lg mb-[24px]"
            dangerouslySetInnerHTML={{ __html: records.message }}
          />
          {records.showCookingTime && (
            <CustomInput
              placeholder={`e.g. for 40 minutes write 40`}
              value={cookingTime}
              setValue={updateCookingTime}
              showPadding={false}
              label={`Please write the time required to cook the order`}
              highlight={false}
              required={true}
            />
          )}
          {error && (
            <div className="text-pink text-xs font-ubold">{error}</div>
          )}
          <Divider />
        </div>
      </Modal>
    </ConfigProvider>
  );
}

export default ConfirmationModal;
